import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

const AloneCol = ({ children, justify, ...props }) => (
  <Col span={24}>
    <Row justify={justify}>
      <Col {...props}>{children}</Col>
    </Row>
  </Col>
);

AloneCol.propTypes = {
  children: PropTypes.node.isRequired,
  justify: PropTypes.string,
};

AloneCol.defaultProps = {
  justify: undefined,
};

export default AloneCol;
